module.exports = __webpack_public_path__ + "static/media/logo_expanded.08ceaf14.png";